import React from 'react'

import { VideoTrack } from '../../../../MediaTracks/components/VideoTrack/VideoTrack'
import { useParticipant } from '../../../../webrtc/webRTCRoom'
import { posToStyle, useFeedPosition } from '../../../layouts'

interface FloorCameraFeedProps {
  id: number
}

const FloorMobileFeed = ({ id }: FloorCameraFeedProps) => {
  const participant = useParticipant(id)
  const position = useFeedPosition('mobile', id)

  if (!participant?.tracks.mobile) return null

  return (
    <div className="participant-mobile-track" style={posToStyle(position)}>
      <VideoTrack track={participant.tracks.mobile} objectFit="contain" />
    </div>
  )
}

export { FloorMobileFeed }
